/**
 * Cookie notice. The bar ships in the markup with `hidden` set, so it only
 * appears for visitors who have not acknowledged it yet — no flash of a bar
 * that is about to be dismissed on every page load.
 *
 * The choice lives in localStorage rather than a cookie: nothing server-side
 * needs to read it, and this way the notice itself sets no cookie.
 */
const STORAGE_KEY = 'coolair-cookie-notice';

function hasAcknowledged() {
	try {
		return window.localStorage.getItem( STORAGE_KEY ) === 'ok';
	} catch ( error ) {
		// Private-mode / blocked storage: treat as acknowledged so a visitor
		// who cannot persist the choice isn't shown the bar on every page.
		return true;
	}
}

function remember() {
	try {
		window.localStorage.setItem( STORAGE_KEY, 'ok' );
	} catch ( error ) {
		// Nothing to do — the bar still closes for this page view.
	}
}

export function initCookieNotice() {
	const bar = document.querySelector( '[data-cookie-bar]' );

	if ( ! bar || hasAcknowledged() ) {
		return;
	}

	bar.hidden = false;
	// Next frame, so the entrance transition has a start state to animate from.
	requestAnimationFrame( () => bar.classList.add( 'is-visible' ) );

	bar.querySelector( '[data-cookie-accept]' )?.addEventListener( 'click', () => {
		remember();
		bar.classList.remove( 'is-visible' );

		const done = () => {
			bar.hidden = true;
		};

		// Wait for the exit transition where there is one, but never hang on it.
		bar.addEventListener( 'transitionend', done, { once: true } );
		window.setTimeout( done, 400 );
	} );
}
